import _ from 'lodash';
import fields from '@/config/forms';

export default {
  data() {
    return {
      validateFieldKey: '',
      beforeModifiedFields: {},
      modifiedFields: [],
      modifiedFieldCustom: null,
      sortByFields: null,
      first: true,
      optionalFields: null,
      formatFieldValue: null
    };
  },
  created() {
    this.modifiedFields = fields[this.validateFieldKey]['modifiedFields'] || [];
    this.modifiedFieldCustom = fields[this.validateFieldKey]['modifiedFieldCustom'] || null;
    this.sortByFields = fields[this.validateFieldKey]['sortByFields'] || null;
    this.optionalFields = fields[this.validateFieldKey]['optionalFields'] || null;
    this.formatFieldValue = fields[this.validateFieldKey]['formatFieldValue'] || null;
  },

  computed: {
    changedFieldData() {
      let obj = {};
      for (let item of this._applyOptionalFields()) {
        obj[item] = this[item];
      }
      return this._checkChangedData(this.beforeModifiedFields, obj);
    }
  },
  methods: {
    _formatValueField(key, value) {
      if (this.formatFieldValue && key && Object.keys(this.formatFieldValue).includes(key)) {
        return this.formatFieldValue[key](value);
      }
      return value;
    },

    setFieldsBeforeModify(override = false) {
      if (!this.first && !override) return;
      if (!this.modifiedFields.length) return;
      const beforeModifiedObject = {};
      for (let item of this._applyOptionalFields()) {
        beforeModifiedObject[item] = this[item];
      }
      this.beforeModifiedFields = _.cloneDeep(beforeModifiedObject);
      if (!override) this.first = false;
    },

    _applyOptionalFields() {
      const extendModifiedFields = _.cloneDeep(this.modifiedFields);
      for (let item of this.modifiedFields) {
        if (this.optionalFields && Object.keys(this.optionalFields).includes(item)) {
          for (let fields of this.optionalFields[item][this[item]]) {
            extendModifiedFields.push(fields);
          }
        }
      }
      return extendModifiedFields;
    },
    _checkChangedData(originalObj, modifiedObj) {
      const obj1 = _.cloneDeep(originalObj);
      const obj2 = _.cloneDeep(modifiedObj);
      return !this._isDeepEqualObj(obj1, obj2);
    },
    _convertFormatValue(originValue, modifiedValue, key = '') {
      if (
        originValue &&
        modifiedValue &&
        (typeof originValue === 'string' || typeof modifiedValue === 'string')
      ) {
        const originStr = _.trim(originValue.toString());
        const modifiedStr = _.trim(modifiedValue.toString());
        return this._formatValueField(key, originStr) !== this._formatValueField(key, modifiedStr);
      }
      return this._formatValueField(key, originValue) != this._formatValueField(key, modifiedValue);
    },

    _isDeepEqualObj(obj1, obj2, customKeys = []) {
      let customKeyArr;
      const keysObj1 = Object.keys(obj1);
      const keysObj2 = Object.keys(obj2);
      const interSectionKeys = _.intersection(keysObj1, keysObj2);
      const filterKeys = customKeys.length > 0 ? customKeys : interSectionKeys;
      for (let key of filterKeys) {
        if (this.modifiedFieldCustom[key]) {
          customKeyArr = this.modifiedFieldCustom[key];
        }
        const isObject = _.isObject(obj1[key]) && _.isObject(obj2[key]);
        const isArray = _.isArray(obj1[key]) && _.isArray(obj2[key]);
        if (isObject && !isArray && !this._isDeepEqualObj(obj1[key], obj2[key], customKeyArr)) {
          return false;
        }
        if (isArray && !this._isEqualArr(obj1[key], obj2[key], key)) {
          return false;
        }
        if (!isObject && !isArray && this._convertFormatValue(obj1[key], obj2[key], key)) {
          return false;
        }
      }
      return true;
    },

    _isEqualArr(arr1, arr2, key = '') {
      let originalArr, modifiedArr, customKeys;
      if (arr1.length !== arr2.length) return false;
      if (this.sortByFields && this.sortByFields[key]) {
        originalArr = _.orderBy(arr1, this.sortByFields[key], this.sortByFields.orderBy);
        modifiedArr = _.orderBy(arr2, this.sortByFields[key], this.sortByFields.orderBy);
      } else {
        originalArr = arr1.sort();
        modifiedArr = arr2.sort();
      }
      if (this.modifiedFieldCustom[key]) {
        customKeys = this.modifiedFieldCustom[key];
      }
      for (let i = 0; i < originalArr.length; i++) {
        const isObject = _.isObject(originalArr[i]) && _.isObject(modifiedArr[i]);
        const isArray = _.isArray(originalArr[i]) && _.isArray(modifiedArr[i]);
        if (
          isObject &&
          !isArray &&
          !this._isDeepEqualObj(originalArr[i], modifiedArr[i], customKeys)
        )
          return false;
        if (isArray && !this._isEqualArr(originalArr[i], modifiedArr[i])) return false;
        if (!isObject && !isArray && this._convertFormatValue(originalArr[i], modifiedArr[i]))
          return false;
      }
      return true;
    },
    showMessageWhenChange(fn) {
      if (this.changedFieldData) {
        const message =
          `<div>` +
          this.t('message.notNotifyWritingInfo') +
          `</br>` +
          this.t('message.moveTheScreenNotify') +
          `</div>`;
        this.$alert(message, this.t('page.eventStatus.notice'), {
          cancel: () => {},
          action: () => {
            fn();
          }
        });
      } else fn();
    }
  }
};
